import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const IngredientCategorisation = ApplicationRecord.extend({
  attrs: {
    id: attr(),
    family: attr(),
    category: attr(),
    subcategory: attr(),
  },
  static: {
    endpoint: '/ingredient_categorisations',
    jsonapiType: 'recipes-ingredient_categorisations',
  },
  methods: {
    label() {
      if (this.family && this.category && this.subcategory) {
        return [this.family, this.category, this.subcategory].join(' › ');
      }
      return '';
    },
  },
});

export default IngredientCategorisation;
